import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
// tailwind
import './tailwind.css'

// plugins
import './plugins/common-components';
import './plugins/veeValidate/veeValidate';
import i18n from './plugins/i18n';
import './plugins/sweetAlert2/sweetAlert2';
import './mixins/ultiMixins';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import vSelect from 'vue-select'
import './sass/index.scss';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.component('vSelect', vSelect);
Vue.use(Antd)
new Vue({
    router,
    i18n,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
